import { render, staticRenderFns } from "./SectionSustainabilityV3.vue?vue&type=template&id=357f96ea&"
import script from "./SectionSustainabilityV3.vue?vue&type=script&lang=js&"
export * from "./SectionSustainabilityV3.vue?vue&type=script&lang=js&"
import style0 from "./SectionSustainabilityV3.vue?vue&type=style&index=0&id=357f96ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitle: require('/app/components/atoms/common/AtomTitle.vue').default,OrganismsCommonOrganismCertificationsV2: require('/app/components/organisms/common/OrganismCertificationsV2.vue').default})
